import { createSlice } from "@reduxjs/toolkit";


const initialServiceState = {
    listLoading: false,
    actionsLoading: false,
    serviceTypesTotalCount: 0,
    serviceTypes: [], 
    lastError: null
  };

export const callTypes = {
  list: "list",
  action: "action"
};
  

const serviceSlice = createSlice({
    name: 'services',
    initialState:initialServiceState,
    reducers: {
        catchError: (state, action) => {
          state.error = `${action.type}: ${action.payload.error}`;
          if (action.payload.callType === callTypes.list) {
            state.listLoading = false;
          } else {
            state.actionsLoading = false;
          }
        },
        startCall: (state, action) => {
          state.error = null;
          if (action.payload.callType === callTypes.list) {
            state.listLoading = true;
          } else {
            state.actionsLoading = true;
          }
        },
        servicesFetched: (state, action) => {
          const { totalCount, services } = action.payload;
          state.listLoading = false;
          state.error = null;
          state.serviceTypes = services;
          state.serviceTypesTotalCount = totalCount;
        }
      }
});

export const { actions } = serviceSlice;
export const { reducer } = serviceSlice;